import React, {useEffect} from "react";
import useTranslateOrDefault from "../hooks/useTranslateOrDefault";
import Tiles from "../components/Tiles";

/**
 * Index page of the site ("/" location)
 */
const Index = () => {
    const appTitle: string = useTranslateOrDefault("app-title", "docs.cloudogu.com");

    useEffect(() => {
        document.title = `${appTitle}`
    });

    return (
        <Tiles location={[]} slug={""} delocalizedSlug={""}/>
    );
};

export default Index;
